import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Compfoto from '../Checkout/Compfoto';
import Compwasit from '../Checkout/Compwasit';
import Combola from '../Checkout/Combola';
import Comprompi from '../Checkout/Compromi';
import Complayananfoto from './Complayananfoto';
import Complayananwasit from './Complayananwasit';
import Complayanananbola from './Complayanananbola';
import Complayananrompi from './Complayananrompi';
import Pembayaran2 from '../../pages/Pembayaran2';
import Comppembayaran from './Comppembayaran';


export default function Compmain({ kodebooking, kodebooking2 }) {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const [dataBook, setDataBook] = useState([]);
    const [totalHarga, setTotalHarga] = useState(0);
    const [foto, setFoto] = useState(0);
    const [wasit, setWasit] = useState(0);
    const [rompi, setRompi] = useState(0);
    const [bola, setBola] = useState(0);


    const getDataBook = async () => {
        try {
            const response = await axios.get(urlapi + "DataBookingUser?kode=" + kodebooking);
            setDataBook(response.data);
            console.log(response.data);

        } catch (error) {
            console.log(error.message);

        }
    }

    const formatrupiah = (numb) => {
        const format = numb.toString().split("").reverse().join("");
        const convert = format.match(/\d{1,3}/g);
        const rupiah = "Rp " + convert.join(".").split("").reverse().join("");
        return rupiah;
    };

    const updateTotalHarga = () => {
        const data = JSON.parse(localStorage.getItem("bookingData")) || [];
        const total = data.reduce((sum, item) => sum + parseInt(item.harga), 0);
        setTotalHarga(total);
        localStorage.setItem("totalHarga", total);
    };

    useEffect(() => {
        getDataBook();
        // const data = JSON.parse(localStorage.getItem('bookingData')) || [];
        // let total = data.reduce((sum, item) => {
        //     return sum + parseInt(item.harga);
        // }, 0);
        // console.log('totalhargabaru :', total);

        const total = parseInt(localStorage.getItem("totalHarga")) || 0;
        setTotalHarga(total);

    }, [])
    return (
        <div style={{ height: '100%' }}>
            <div className="card mt-5 mb-3 text-white" id="bglistpemain">
                <div className="card-body">
                    <h5>Halaman Tambah Layanan </h5>
                    <small>
                        <i className="fas fa-"></i>
                        Anda dapat menambahkan layanan wasit, fotografer, videografer,
                        rompi dan bola untuk booking lapangan anda
                    </small>
                </div>
            </div>
            <hr />
            <div className="card">
                <div className="card-body">
                    <div className="mt-3" style={{ color: "#2b2e5a" }}>
                        <small className="fw-bold "><i className="fas fa-calendar-days"></i> Jadwal booking yang anda pilih  </small>
                    </div>

                    {dataBook.map((data, index) => {
                        return (
                            <div key={index}>
                                <div className="card mb-2 shadow" style={{ borderColor: '#2b2e5a' }}>
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between  fw-bold" style={{ color: "#2b2e5a" }}>
                                            <div>
                                                <small><i className="fas fa-clock"></i> {data.jam_mulai} - {data.jam_selesai}</small>

                                            </div>
                                            <div>
                                                <small><i className="fas fa-calendar-day"></i> {data.tgl}</small>
                                                <div className="text-end">

                                                    {/* <span onClick={() => hapusItem(data.id, data.tanggal)} class="badge bg-danger"><i className="fas fa-trash"></i></span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <small style={{ color: '#2b2e5a', fontWeight: 'bold' }}><i className="fas fa-futbol"></i> {data.lapangan}</small>
                                        <hr />
                                        <Complayananfoto onUpdateTotal={updateTotalHarga} tanggal={data.tgl} jammulai={data.jam_mulai} />
                                        <Complayananwasit onUpdateTotal={updateTotalHarga} />
                                        <Complayanananbola onUpdateTotal={updateTotalHarga} />
                                        <Complayananrompi onUpdateTotal={updateTotalHarga} />
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>


                <div className="mt-5">
                    <div className="card fixed-bottom" style={{ border: "none" }}>
                        <div className="card-body">
                            <div className="container">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <label className="fw-bold" style={{ color: "#2b2e5a" }}>
                                            Total : {formatrupiah(totalHarga)}
                                        </label>
                                    </div>
                                    <div>
                                        {/* <Pembayaran2 /> */}
                                        <Comppembayaran kodebooking={kodebooking} kodebooking2={kodebooking2} totalharga={totalHarga} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
